// extracted by mini-css-extract-plugin
export default {"main_container":"DonorFundraiser_main_container__W+oG1","right_panel":"DonorFundraiser_right_panel__7Xlgu"};